import { SupplierRegistrationCountryFields } from '@supplierRegistration/domain/supplierRegistrationCountryFields';

enum ItalyLegalIdTypesForCompany {
  VAT = 'VAT',
  Other = 'Other',
}

export const IT: SupplierRegistrationCountryFields = {
  leis: { types: ItalyLegalIdTypesForCompany },
};
